const loaded = { currentIds: [] };

export function initGA4(platformId, customId) {
  const ids = [platformId, customId].filter(Boolean);
  if (!ids.length) return;

  if (loaded.currentIds.join() === ids.join()) return;
  loaded.currentIds = ids;

  const existing = document.getElementById('ga4-tag');
  if (existing) existing.remove();

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  script.id = 'ga4-tag';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  ids.forEach((id) => {
    gtag('config', id, { send_page_view: false });
  });
}

export function sendPageView(path) {
  const ids = loaded.currentIds;
  if (!window.gtag || !ids.length) return;
  ids.forEach((id) => {
    window.gtag('event', 'page_view', { page_path: path });
  });
}
